//import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { Box, Chip, Stack } from "@mui/material";
import { ApiQueries, DaymapIcon, DaymapIconType, prettyDateRange, DaymapSkeleton, EventDetails, LessonPlans, EventRooms } from "daymap-react";
import { PageContainer } from "../../../../components/layout";
import PageHeader from '../../../../containers/pageheader/pageheader';
import { useParams, useNavigate } from "react-router-dom";

function EventView(){
  const {studentId, eventId} = useParams();
  const {isPending, data} = new ApiQueries.calendars.EventDetails({eventID: Number(eventId), studentID: Number(studentId)}).ToQuery();
  const navigate = useNavigate();

  if (isPending)
    return <PageContainer>
      <DaymapSkeleton type="page" />
    </PageContainer>

  const { Event, Plans } = data!;

  return <>
      <PageHeader onBackButtonClick={() => navigate(-1)}>
        <Stack alignItems="center" gap={.5}>
          <span>{data?.Event.Title}</span>
        </Stack>
      </PageHeader>
      <Box display="flex" justifyContent="center" alignItems="center" gap={1} pb={.5} pt={1}>
            <Chip size="small" label={prettyDateRange(Event.Start, Event.Finish)} icon={<DaymapIcon iconType={DaymapIconType.Schedule} />} />
            <EventRooms resources={Event.Resources} />
      </Box>
      <PageContainer>
        <Stack gap={3}>
          <EventDetails {...data!} studentId={Number(studentId)} />
          {Plans && <LessonPlans plans={Plans} />}
        </Stack>
      </PageContainer>
  </>
}

export default EventView;